module.exports = __webpack_public_path__ + "img/mine-header.ad4fa548.png";